'use strict';

module.exports = require('./is-implemented')()
	? Object.assign
	: require('./shim');



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/assign/index.js
// module id = 40
// module chunks = 0